import RequiredStar from './requiredStar';
import { slugify } from '../helpers/helpers';
import H4 from './h4';
import Spacer from './spacer';

function InnerRadio(props) {
  const {
    options, value, onChange, label, name, error, required,
  } = props;

  return (
    <>
      {label && (
        <>
          <H4>
            <div className="flex items-center">
              {label}
              {required && (
                <RequiredStar customStyles={{ height: 8, marginLeft: 4 }} />
              )}
            </div>
          </H4>
          <Spacer thin />
        </>
      )}

      <div className="flex flex-row">
        {options.map((o) => (
          <div key={slugify(`${o.label}${name}`)}>
            <input
              onChange={onChange}
              className="text-sentric-dark-gray"
              id={slugify(`${o.label}${name}`)}
              type="radio"
              name={name}
              value={o.value}
              defaultChecked={value !== null && o.value === value}
            />
            <label className="p-2" htmlFor={slugify(`${o.label}${name}`)}>
              {o.label}
            </label>
          </div>
        ))}
      </div>
      {!!error && (
        <p className="w-4/5 error-arrow-top text-sm inline-block p-1 pr-3 pl-3 bg-red-700 mt-2 text-white rounded-lg border-white border">
          {error}
        </p>
      )}
    </>
  );
}

export default InnerRadio;
